import React from "react";
import Logo from "../../assets/logos/logo-forager-white.svg";
import icon from "../../assets/icons/btn-arrow-left.svg";
import { NavLink } from "react-router-dom";

const CompanyDescription = ({ logo, styleLogo, map, link, description }) => {
  return (
    <section className="bg-grey">
      <div>
        <div className="lg:container lg:mx-auto">
          <div className="md:hidden relative grid place-items-center with-curved-bottom bg-no-repeat bg-cover py-16 bg-pages-companies">
            <img
              src={Logo}
              alt="Logo Forager Media Group"
              className="w-36 absolute top-10 pl-5"
            />
          </div>
          <div className="container mx-auto grid grid-cols-9 items-start px-4 lg:px-0 pt-8 lg:pt-44">
            <div className="col-span-9 md:col-span-5 order-1 md:pr-16">
              <img
                src={logo}
                alt=""
                className={`mt-10 md:mt-0 mb-14 2xl:mb-0 mx-auto ${styleLogo}`}
              />
            </div>
            <NavLink to="/companies" className="col-span-9">
              <img
                src={icon}
                alt=""
                className="hidden lg:block w-12 aspect-square absolute top-28"
              />
            </NavLink>
            <div className="flex flex-col-reverse md:flex-col col-span-9 md:col-span-4 order-2 row-span-2">
              <img src={map} alt="" className="w-full mb-11 mx-auto" />
              <a
                href={link.href}
                target="_blank"
                rel="noreferrer"
                className="w-full max-w-sm block py-4 mx-auto rounded-full bg-navy-blue hover:bg-dark-denim text-center mb-12 text-white font-medium shadow-lg"
              >
                {link.name}
              </a>
            </div>
            <article className="col-span-9 md:col-span-5 order-3 row-span-1 md:pr-16">
              {description}
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyDescription;
